import preval from 'preval.macro';
import polyglotI18nProvider from 'ra-i18n-polyglot';
//
import { Admin, CustomRoutes, Resource } from 'react-admin';
import { Route } from "react-router-dom";
import './App.scss';
import en from './locales/en/translation.js';
import zh from './locales/zh/translation.js';
import treeqlProvider from './ra-data-treeql';
import phpCrudApiAuthProvider from './ra-php-crud-api-auth';
import fetchJson from './utils/fetchJson';
import theme from './utils/mui-theme';
import User from './views/admin/User';
import MyProfile from './views/pages/MyProfile';
//
import Activities from './views/admin/Activities';
import ApplicationForm from './views/admin/ApplicationForm';
import Audio from './views/admin/Audio';
import Book from './views/admin/Book';
import Channel from './views/admin/Channel';
import EmailTemplate from './views/admin/EmailTemplate';
import EmailLog from './views/admin/EmailLog';
import ContentNode, { PageContentNodeMeta } from './views/admin/ContentNode';
import Donation from './views/admin/Donation';
import Highlight from './views/admin/Highlight';
import Opinion from './views/admin/Opinion';
import Questions from './views/admin/Questions';
import Option from './views/admin/Option';
import Reading from './views/admin/Reading';
import OgRedirect from './views/admin/OgRedirect';
import SharingOthers from './views/admin/SharingOthers';
import SiteConfig from './views/admin/SiteConfig';
import Volunteer from './views/admin/Volunteer';
//
import Dashboard from './views/layout/Dashboard';
import ProjectLayout from './views/layout/ProjectLayout';
import { BASE_URL } from './utils/api';
import { QueryClient } from 'react-query';
import AppConfigProvider from 'utils/providers/AppConfigProvider';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      structuralSharing: false,
    },
    mutations: {
      retryDelay: 10000,
    },
  },
});
//
const dateTimeStamp = preval`module.exports = new Date().toISOString();`;
console.log('Build date: ', dateTimeStamp, ' @ ', process.env.NODE_ENV);
console.log('Base URL: ', BASE_URL);
('development' === process.env.NODE_ENV) && console.log('process.env: ', process.env);
//
const authProvider = phpCrudApiAuthProvider(`${BASE_URL}api`);
const dataProvider = treeqlProvider(`${BASE_URL}api`, fetchJson);

const translations = { en, zh };
export const i18nProvider = polyglotI18nProvider(
  (locale) => translations[locale as 'en' | 'zh'],
  'en',
  [{ locale: 'en', name: 'English' }, { locale: 'zh', name: '正體中文' }],
);

//
const App = () => (
  <AppConfigProvider>
    <Admin
      disableTelemetry
      title={process.env.REACT_APP_TITLE}
      dashboard={Dashboard}
      queryClient={queryClient}
      layout={ProjectLayout}
      theme={theme}
      i18nProvider={i18nProvider}
      dataProvider={dataProvider}
      authProvider={authProvider}
      requireAuth
    >
      {permissions => <>
          {/* <Resource name={`daily_transaction`} {...DailyTransaction} options={{ group: "misc" }} /> */}
          {authProvider.isSimpleAclAllowed('content_node') ? <Resource name={`content_node`} {...ContentNode} options={{ group: "cms" }} /> : null}

          {authProvider.isSimpleAclAllowed('donation') ? <Resource name={`donation`} {...Donation} options={{ group: "feature" }} /> : null}
          {authProvider.isSimpleAclAllowed('volunteer') ? <Resource name={`volunteer`} {...Volunteer} options={{ group: "feature" }} /> : null}
          {authProvider.isSimpleAclAllowed('application_form') ? <Resource name={`application_form`} {...ApplicationForm} options={{ group: "feature" }} /> : null}
          {authProvider.isSimpleAclAllowed('email_template') ? <Resource name={`email_template`} {...EmailTemplate} options={{ group: "feature" }} /> : null}
          {authProvider.isSimpleAclAllowed('email_log') ? <Resource name={`email_log`} {...EmailLog} options={{ group: "feature" }} /> : null}

          {authProvider.isSimpleAclAllowed('activities') ? <Resource name={`activities`} {...Activities} options={{ group: "site_content" }} /> : null}
          {authProvider.isSimpleAclAllowed('audio') ? <Resource name={`audio`} {...Audio} options={{ group: "site_content" }} /> : null}
          {authProvider.isSimpleAclAllowed('book') ? <Resource name={`book`} {...Book} options={{ group: "site_content" }} /> : null}
          {authProvider.isSimpleAclAllowed('channel') ? <Resource name={`channel`} {...Channel} options={{ group: "site_content" }} /> : null}
          {authProvider.isSimpleAclAllowed('highlight') ? <Resource name={`highlight`} {...Highlight} options={{ group: "site_content" }} /> : null}
          {authProvider.isSimpleAclAllowed('opinion') ? <Resource name={`opinion`} {...Opinion} options={{ group: "site_content" }} /> : null}
          {authProvider.isSimpleAclAllowed('questions') ? <Resource name={`questions`} {...Questions} options={{ group: "site_content" }} /> : null}
          {authProvider.isSimpleAclAllowed('option') ? <Resource name={`option`} {...Option} options={{ group: "site_content" }} /> : null}
          {authProvider.isSimpleAclAllowed('reading') ? <Resource name={`reading`} {...Reading} options={{ group: "site_content" }} /> : null}
          {authProvider.isSimpleAclAllowed('sharing_others') ? <Resource name={`sharing_others`} {...SharingOthers} options={{ group: "site_content" }} /> : null}

          {authProvider.isSimpleAclAllowed('og_redirect') ? <Resource name={`og_redirect`} {...OgRedirect} options={{ group: "misc" }} /> : null}

          {authProvider.isSimpleAclAllowed('site_config') ? <Resource name={`site_config`} {...SiteConfig} options={{ group: "misc", recordId: 1 }} /> : null}

          {(permissions && ('system_admin' === permissions.role))
            ?
            <>
              <Resource name={`user`} {...User} options={{ group: "user" }} />
            </>
            : null}

          <CustomRoutes>
            <Route path="/my-profile" element={<MyProfile />} />
            <Route path="/content-node-meta/:mode/:id/*" element={<PageContentNodeMeta />} />
          </CustomRoutes>
        </>
      }
    </Admin>
  </AppConfigProvider>
);
export default App;
